import { RouteProps } from 'react-router-dom';

import { ReducerObject } from '@hh.ru/redux-create-reducer';

export type MicroServiceName = string;
export type RootReducer = Record<string, ReducerObject>;
export type AppRoutes = RouteProps[];

export interface ExperimentsState {
    checked: string[];
    enabled: Record<string, unknown>;
}

export interface TrlState {
    [key: string]: { [key: string]: string };
}

export interface PageErrorState {
    code: number;
}

export interface RequestData {
    pageName: string;
    protocol: string;
    host: string;
    url: string;
    id: string | null;
    xsrfToken: string;
}

export interface AssetsManifest {
    entrypoints: string[];
}

export interface Locale {
    areaId: string;
    domainAreaId: string;
    host: string;
    protocolHost: string;
    isSeoDomain: boolean;
    platform: Platform;
    availableLanguages: [`${SiteLanguages}`];
    siteLanguage: SiteLanguages;
}

export enum Platform {
    HeadHunter = 'HEADHUNTER',
    Zarplata = 'ZARPLATA',
}

export enum SiteLanguages {
    RU = 'RU',
    EN = 'EN',
    AZ = 'AZ',
    UA = 'UA',
    KZ = 'KZ',
    UZ = 'UZ',
    KG = 'KG',
}

export enum DisplayType {
    Desktop = 'DESKTOP',
    Mobile = 'MOBILE',
    Tablet = 'TABLET',
}

export type FetchDataErrorType = unknown;

declare global {
    /* eslint-disable-next-line  @typescript-eslint/no-empty-interface */
    interface LuxRequest extends RequestData {}
}
